import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import ExpansionPanel from "@material-ui/core/ExpansionPanel"
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary"
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { useStore } from "../../teafuljs/store"
import SourceIcons from "../../data/SourceIcons.json"
import LinearProgress from "@material-ui/core/LinearProgress"
import { getTranslation } from "../../scripts/getTranslation"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  ExpansionPanelSummary: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "& .MuiExpansionPanelSummary-expandIcon": {
      color: "white",
    },
    borderRadius: 5,
  },
  recipient: {
    display: "flex",
    margin: "10px 0 10px 0",
  },
  SVicons: {
    height: "20px",
    width: "20px",
    margin: 0,
  },
  blackButton: {
    color: "black",
    backgroundColor: "rgb(201, 201, 201)",
    borderColor: "black",
    margin: "2px",
  },
  redButton: {
    color: "#d60000",
    backgroundColor: "#ffadad",
    borderColor: "#d60000",
    margin: "2px",
  },
  greenButton: {
    color: "#006400",
    backgroundColor: "#b9f8b9",
    borderColor: "#006400",
    margin: "2px",
  },
  blueButton: {
    color: "darkblue",
    backgroundColor: "rgb(142, 227, 255)",
    borderColor: "darkblue",
    margin: "2px",
  },
  links: {
    margin: 0,
  },
  recipName: {
    margin: 0,
    marginLeft: 10,
    // textAlign: "right",
    // flex: '0 1 200px'
  },
  wordCountDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  line: {
    flex: 4,
    margin: "auto 0",
  },
  wordCount: {
    fontSize: "70%",
    color: "grey",
    textAlign: "right",
    flex: 1,
    margin: 0,
  },
}))

export default function SimpleExpansionPanel({ sources }) {
  const language = useStore.language()[0]
  const translations = useStore.translations()[0]
  const classes = useStyles()
  const [totalWords, setTotalWords] = useState()
  const [sourcesList, setSourcesList] = useState([])

  useEffect(() => {
    getTopSources(sources)
  }, [])
  const getTopSources = obj => {
    const sourceNames = Object.keys(obj)
    let totalCountedWords = 0
    let sourcesArray = sourceNames.map(sourceName => {
      totalCountedWords = totalCountedWords + obj[sourceName].words
      return {
        key: sourceName,
        val: obj[sourceName].words,
        color: obj[sourceName].color,
      }
    })

    setTotalWords(totalCountedWords)

    sourcesArray = sourcesArray.sort(function(a, b) {
      if (a.val > b.val) {
        return -1
      } else if (a.val < b.val) {
        return 1
      } else if (a.val === b.val) {
        return 0
      }
      return 0
    })
    const topSources = []
    let count = 0
    sourcesArray.forEach(source => {
      if (source.key !== "The Narrator") {
        topSources.push({
          name: source.key,
          words: source.val,
          color: source.color,
        })
        count += 1
      } else return
    })
    setSourcesList(topSources)
  }

  return (
    <div className={classes.root}>
      <ExpansionPanel>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.ExpansionPanelSummary}
        >
          <Typography className={classes.heading}>
            {getTranslation(
              translations,
              language,
              "UI",
              "sourceview_popup_source"
            )}{" - "}
            {sourcesList.length}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>
            {sourcesList.map((s, sIndex) => {
              return (
                <div className={classes.sourceItem} key={`${s.name}-${sIndex}`}>
                  <div className={classes.recipient}>
                    <img
                      src={
                        SourceIcons[s.name]
                          ? require(`../../../static/images/${
                              SourceIcons[s.name].sourceIcon
                            }.png`)
                          : null
                      }
                      className={classes.SVicons}
                      alt=""
                    />
                    <p className={classes.recipName}>
                      {getTranslation(
                        translations,
                        language,
                        "Sources",
                        s.name
                      )}
                    </p>
                  </div>
                  <div className={classes.wordCountDiv}>
                    <LinearProgress
                      className={classes.line}
                      color="primary"
                      variant="determinate"
                      value={Math.min((s.words / totalWords) * 100)}
                    />
                    <p className={classes.wordCount}>
                      ({s.words.toLocaleString()})
                    </p>
                  </div>
                </div>
              )
            })}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  )
}
